import React, { Component } from "react";
import {
  StyledMarketPlaceGallery,
  StyledMarkerplaceCard,
  StyledMarketplaceContent,
  StyledTemplateViewAllSwiperButton,
} from "../_components/styled/home/stylesHome";
import {
  ShowCenterSpinner,
  RequestTemplateContent,
} from "../_components/common/statelessView";
import { batch, connect } from "react-redux";
import DesignCard from "../_components/home/DesignCard";
import { TAB_TEMPLATES } from "../_components/details/constants";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import {
  MAIN_CONTAINER_SCROLLABLE_TARGET_ID,
  NO_ACCESS_TO_CREATE_STORY,
  TEMPLATES_KEY,
} from "../_utils/constants";
import { createStory } from "../_actions/storiesActions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import TldrAiBase from "../TldrAi/TldrAiBase";
import TldrSearch from "../_components/common/TldrSearch";
import {
  fetchCategories,
  resetStories,
  fetchViewAllTemplatesByGroup,
  resetTemplatesViewAll,
  filterTemplatesByCategory,
} from "../_actions/storiesActions";
import { searchFormats } from "../_actions/slidePresetActions";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import queryString from "query-string";
import { TEMPLATES_BY_FORMAT_SCREEN, TEMPLATES_SCREEN } from "../_utils/routes";
import Format from "string-format";
import { encodeWithDash } from "../_utils/common";
import { closeSidebar } from "../_actions/sidebarSliderActions";
import { debounce } from "lodash";
import {
  FaArrowLeft,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaPlus,
  FaSearch,
} from "react-icons/fa";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Icon,
  Text,
  Skeleton,
  Flex,
  Heading,
  Divider,
  Stack,
  DrawerContent,
  DrawerHeader,
} from "@chakra-ui/react";
import { showToast } from "../_utils/showToast";
import { withTranslation } from "react-i18next";
import TLDRTitleSearch from "../_components/common/TLDRTitleSearch";
import TldrMobileSearchSuggestion from "../_components/common/TldrMobileSearchSuggestion";
import TldrSearchSuggestion from "../_components/common/TldrSearchSuggestion";
import Drawer from "../_components/drawer/Drawer";
import { isEmpty } from "lodash";

const heroTextSkeletonStyles = {
  width: "100%",
  height: "20px",
  marginBottom: "0.75rem",
  borderRadius: "4px",
};

class ViewAllTemplates extends Component {
  signal = axios.CancelToken.source();
  constructor(props) {
    super(props);
    const {
      params: { format, category },
    } = this.props.match;
    var querySearchParam = queryString.parse(this.props.location.search).search;

    this.state = {
      searchTerm: querySearchParam,
      requestedCategory: category,
      requestedFormat: format,
      formatDetails: null,
      category: {},
      showSuggestions: false,
      showMobileSuggestions: false,
      isCategoryDrawerOpen: false,
    };
  }

  componentDidMount() {
    batch(() => {
      this.props.closeSidebar();
      this.props.resetStories();
      this.fetchFormatInformation();
      if (!this.state.requestedCategory) {
        this.fetchAllTemplatesByFormat();
      }
      this.props
        .fetchCategories(this.props, this.signal.token)
        .then((categories) => {
          if (categories) {
            const selectedCategory = categories.find((category) => {
              return (
                category.title === this.state.requestedCategory?.toLowerCase()
              );
            });
            this.setState({
              category: selectedCategory
                ? selectedCategory
                : { id: "", title: "All" },
            });
            if (this.state.requestedCategory) {
              this.fetchAllTemplatesByFormat();
            }
          }
        });
    });
  }

  fetchFormatInformation = () => {
    this.props
      .searchFormats(this.state.requestedFormat, this.props)
      .then((response) => {
        this.setState({ formatDetails: response.results[0] });
      });
  };

  fetchAllTemplatesByFormat = () => {
    this.props.resetStories();
    this.props.fetchViewAllTemplatesByGroup(
      this.state.searchTerm,
      this.state.requestedFormat,
      this.state.category?.id,
      1,
      { ...this.props },
      this.signal.token
    );
  };

  loadMoreData = () => {
    this.props.fetchViewAllTemplatesByGroup(
      this.state.searchTerm,
      this.state.requestedFormat,
      this.state.category?.id,
      this.props.stories.page || 1,
      { ...this.props },
      this.signal.token
    );
  };

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  onFilterChange = (key) => {
    if (key.id === this.state.category?.id) {
      return;
    }
    this.setState(
      {
        ...this.state,
        category: key,
        requestedCategory: key.id,
      },
      () => {
        this.filterOrSearchTemplates();
      }
    );
  };

  filterOrSearchTemplates = () => {
    const { category, searchTerm, formatDetails } = this.state;

    // get the search term from search box or from url
    let querySearchParam;

    querySearchParam =
      searchTerm?.length > 0
        ? searchTerm
        : queryString.parse(this.props.location.search).search;

    let url = Format(TEMPLATES_BY_FORMAT_SCREEN, formatDetails?.title);

    if (category) {
      url = `${url}/${encodeWithDash(category?.title)}`;
    }

    this.props.history.replace({
      pathname: encodeURI(url),
      search: searchTerm?.length > 0 ? `?search=${querySearchParam}` : "",
    });

    this.fetchAllTemplatesByFormat();
  };

  handleClick = debounce(() => {
    const { workspacePermissionChecks } = this.props;
    const { canCreateStory } = workspacePermissionChecks;
    if (!canCreateStory) {
      showToast({
        description: NO_ACCESS_TO_CREATE_STORY,
        title: "Limited Access",
        status: "info",
      });
      return;
    }
    const { formatDetails } = this.state;
    this.props.createStory(
      {
        status: "draft",
        format: formatDetails?.id,
        image_height: `${formatDetails.image_height}`,
        image_width: `${formatDetails.image_width}`,
        title: formatDetails?.display_name,
        story_type: formatDetails.story_type,
      },
      this.signal.token,
      this.props
    );
  }, 1000);

  getViewAllHeadings = () => {
    const { formatDetails } = this.state;

    return (
      <>
        {formatDetails ? (
          <>
            <Text fontSize={"2rem"} fontWeight={"bold"} lineHeight={1.1}>
              {formatDetails?.display_name}
            </Text>
            <Text fontSize={"14px"} color={"gray.300"}>
              {formatDetails?.description ||
                `${formatDetails?.image_width} x ${formatDetails?.image_height} px`}
            </Text>
          </>
        ) : (
            <>
              <Skeleton sx={heroTextSkeletonStyles} isLoaded={false} />
              <Skeleton sx={heroTextSkeletonStyles} isLoaded={false} />
          </>
        )}
      </>
    );
  };

  closeAllTemplateType = () => {
    batch(() => {
      this.props.resetStories();
      if (this.props.history.length > 2) {
        this.props.history.goBack();
      } else {
        this.props.history.replace({ pathname: TEMPLATES_SCREEN });
      }
    });
  };

  handleSearchWrapperOnBlur = (event) => {
    if (event.currentTarget.id !== event.relatedTarget?.id) {
      this.setState({ showSuggestions: false });
    }
  };

  handleSearchFocus = () => {
    this.setState({
      showSuggestions: true,
    });
  };

  handleSearch = (keyword) => {
    this.setState(
      {
        searchTerm: keyword,
      }
    );
  };

  render() {
    const viewAllHeadings = this.getViewAllHeadings();
    const { stories, navbar, t, isMobileView } = this.props;
    const {
      category,
      formatDetails,
      searchTerm,
      showSuggestions,
      showMobileSuggestions,
      isCategoryDrawerOpen,
    } = this.state;
    const { loaded, payload, loadMore } = stories;

    const templateCategories =
      [{ id: "", title: "all", display_name: "All" }].concat(
        navbar.payload.results
      ) || [];
    const categoriesView =
      navbar.loaded &&
      templateCategories &&
      templateCategories.map((templateCategory) => {
        return (
          <Button
            key={templateCategory.id}
            variant="outline"
            borderRadius="full"
            borderColor={
              category?.id === templateCategory.id
                ? "primary.400"
                : "transparent"
            }
            _hover={{ bg: "none", borderColor: "primary.400" }}
            _focus={{ borderColor: "primary.400", bg: "none" }}
            _active={{ borderColor: "primary.400", bg: "none" }}
            onClick={() => this.onFilterChange(templateCategory)}
            mr="1rem"
            color="gray.100"
          >
            {templateCategory.display_name}
          </Button>
        );
      });

    let templateTypesContent =
      payload && Array.isArray(payload)
        ? payload.map((template) => {
          return (
            <StyledMarkerplaceCard
              key={template.id}
              height={template.image_height}
              width={template.image_width}
              location="template-marketplace-view-all"
            >
              <DesignCard
                story={template}
                tab={TAB_TEMPLATES}
                showHoverOverlay={true}
                isUsedInSwiper={false}
              />
            </StyledMarkerplaceCard>
          );
        })
        : [];

    templateTypesContent.length > 0
      ? templateTypesContent.unshift(
        <StyledMarkerplaceCard
          location="template-marketplace-view-all"
          onClick={() => this.handleClick()}
          key={0}
        >
          <div className="template-marketplace-empty-container">
            <div className="icon-container">
              <FaPlus />
            </div>
            <span>{`Create ${formatDetails?.display_name}`}</span>
          </div>
        </StyledMarkerplaceCard>
      )
      : templateTypesContent.unshift(<React.Fragment key={0}></React.Fragment>);

    let aspectRatio = payload[0]?.image_width / payload[0]?.image_height;
    const numberOfTiles = 6; // It can be changeable.
    let slidesPerView =
      aspectRatio >= 6
        ? 4
        : aspectRatio >= 2
          ? 3
          : aspectRatio === 1
            ? 5
            : aspectRatio >= 1
              ? numberOfTiles / aspectRatio
              : aspectRatio < 0.3
                ? 12
                : aspectRatio < 0.9 && aspectRatio > 0.8
                  ? 8
                  : numberOfTiles * (aspectRatio + 0.4);

    return (
      <StyledMarketplaceContent>
        {isMobileView ? (
          <>
            <TLDRTitleSearch
              searchConfig={{
                onClear: this.handleSearchClear,
                onFocus: this.handleSearchFocusOnMobile,
              }}
              searchText={searchTerm}
              leftIcon
              goBack={this.closeAllTemplateType}
            />

            {showMobileSuggestions ? (
              <TldrMobileSearchSuggestion
                searchTerm={searchTerm}
                handleShowAllClick={this.handleShowAllSearchTemplates}
                searchInFormats={false}
                isOpen={showMobileSuggestions}
                searchConfig={{
                  handleSearch: this.handleSearch,
                  onBlur: this.handleSearchBlurOnMobile,
                  handleEnterKeyEvent: this.handleShowAllSearchTemplates,
                  onClear: this.handleSearchClear,
                }}
                searchIn={TEMPLATES_KEY}
              />
            ) : null}

            <Button
              rightIcon={
                isCategoryDrawerOpen ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )
              }
              onClick={() =>
                this.setState({ isCategoryDrawerOpen: true })
              }
              ml={3}
              isLoading={!navbar.loaded}
            >
              {!isEmpty(category) && category?.id !== "" ? category.display_name : "Categories"}
            </Button>

            <Drawer
              isOpen={isCategoryDrawerOpen}
              onClose={() => this.setState({ isCategoryDrawerOpen: false })}
              placement="bottom"
            >
              <Flex alignItems="center">
                <Heading as="h5" size="md" mr="2">
                  {t("filters.heading")}
                </Heading>
              </Flex>
              <Divider mt="2" mb="4" ml="-6" mr="-6" width="auto" />
              <Stack
                spacing="4"
                mb="4"
                maxH="430px"
                overflowY="auto"
                sx={{
                  "-ms-overflow-style": "none",
                  "scrollbar-width": "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                {navbar.loaded &&
                  templateCategories &&
                  templateCategories.map((templateCategory) => (
                    <Heading
                      as="h6"
                      size="sm"
                      m="0"
                      key={templateCategory.id}
                      onClick={() => {
                        this.setState({
                          isCategoryDrawerOpen: false,
                        }, () =>
                          this.onFilterChange(templateCategory)
                        )
                      }}
                      color={category?.id === templateCategory.id && "primary.200"}
                    >
                      {templateCategory.display_name}
                    </Heading>
                  ))}
              </Stack>
            </Drawer>
          </>
        ) : null}

        <Box
          my={8}
          display={["none", "none", "block", "block"]}
        >
          <Breadcrumb
            separator={
              <Icon as={FaChevronRight} boxSize={3} color="gray.100" />
            }
            ml={10}
          >
            <BreadcrumbItem>
              <BreadcrumbLink onClick={this.closeAllTemplateType}>
                {t("featured_templates.templates")}
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage={category?.id === ""}>
              <BreadcrumbLink
                onClick={() => this.onFilterChange(templateCategories[0])}
              >
                {formatDetails?.display_name}
              </BreadcrumbLink>
            </BreadcrumbItem>

            {category?.id !== "" ? (
              <BreadcrumbItem isCurrentPage>
                <BreadcrumbLink>
                  {this.state.category?.display_name}
                </BreadcrumbLink>
              </BreadcrumbItem>
            ) : null}
          </Breadcrumb>
        </Box>

        <TldrAiBase
          className="templates-header-box templates-view-all"
          cardBodyClassName="card-body marketplace-templates-card-body"
        >
          <div className="view-all-templates-info-container">
            <div className="view-all-templates-title">
              <div className="go-back" onClick={this.closeAllTemplateType}>
                <FaArrowLeft />
              </div>

              <Box ml={6}>
                {viewAllHeadings}

                <div
                  id="tldr-templates-search-wrapper"
                  tabIndex={0}
                  onBlur={(e) => this.handleSearchWrapperOnBlur(e)}
                >
                  <TldrSearch
                    onSearch={this.handleSearch}
                    size="lg"
                    searchLocation="dashboard"
                    placeholder={t("search.search_placeholder")}
                    width="400px"
                    onFocus={this.handleSearchFocus}
                    handleEnterKeyEvent={() => {
                      this.setState({
                        showSuggestions: false
                      }, () =>
                        this.filterOrSearchTemplates()
                      );
                    }}
                    onClear={this.handleSearchClear}
                  />

                  {showSuggestions && (
                    <TldrSearchSuggestion
                      width="400px"
                      searchTerm={searchTerm}
                      searchLocation="dashboard"
                      handleShowAllClick={this.handleShowAllSearchTemplates}
                      searchInFormats={false}
                    />
                  )}
                </div>
              </Box>
            </div>
          </div>

          <img
            src={formatDetails?.hero || formatDetails?.image}
            style={{ height: "100%", width: "auto" }}
            alt={formatDetails?.display_name}
          />
        </TldrAiBase>

        {navbar.loaded && !isMobileView ? (
          <TLDRSwiper swiperParams={viewAllTemplateCategoriesSwiperParams}>
            {categoriesView}
          </TLDRSwiper>
        ) : null}

        <StyledMarketPlaceGallery>
          {loaded && payload.length > 0 ? (
            <TLDRInfiniteScroll
              childrens={templateTypesContent}
              className="view-all-templates-infinite-scroll"
              loadMoreData={this.loadMoreData}
              hasMore={loadMore}
              scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
              wrapChildrenInCustomGrid
              templatesPerRow={Math.ceil(slidesPerView)}
            />
          ) : loaded && payload.length === 0 ? (
            <>
              {templateTypesContent}
              <RequestTemplateContent
                text={t("featured_templates.no_templates")}
              ></RequestTemplateContent>
            </>
          ) : (
            <ShowCenterSpinner loaded={loaded} />
          )}
        </StyledMarketPlaceGallery>
      </StyledMarketplaceContent>
    );
  }

  handleSearchFocusOnMobile = () => {
    this.setState({
      showMobileSuggestions: true,
    });
  };

  handleSearchBlurOnMobile = () => {
    this.setState({
      showMobileSuggestions: false,
    });
  };

  handleShowAllSearchTemplates = (keyword) => {
    this.setState(
      {
        searchTerm: keyword,
        showSuggestions: false,
        showMobileSuggestions: false,
      },
      () => {
        this.filterOrSearchTemplates();
      }
    );
  };

  handleSearchClear = (keyword) => {
    this.setState({
      searchTerm: keyword,
      showSuggestions: false,
      showMobileSuggestions: false,
    }, () => {
      this.filterOrSearchTemplates();
    });
  };
}

let viewAllTemplateCategoriesSwiperParams = {
  slidesPerView: "auto",
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  mousewheel: false,
  containerClass: "marketplace-templates-category-swiper-container",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    disabledClass: "swiper-button-disabled",
  },
  renderPrevButton: () => (
    <StyledTemplateViewAllSwiperButton
      className={"swiper-button-prev"}
      variance="left"
    >
      <div className="swiper-button-inner-div">
        <FaChevronLeft />
      </div>
    </StyledTemplateViewAllSwiperButton>
  ),
  renderNextButton: () => (
    <StyledTemplateViewAllSwiperButton
      className={"swiper-button-next"}
      variance="right"
    >
      <div className="swiper-button-inner-div">
        <FaChevronRight />
      </div>
    </StyledTemplateViewAllSwiperButton>
  ),
};

ViewAllTemplates.propTypes = {};

const mapStateToProps = (state) => ({
  stories: state.stories,
  navbar: state.navbar,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = {
  createStory,
  fetchCategories,
  resetStories,
  fetchViewAllTemplatesByGroup,
  resetTemplatesViewAll,
  filterTemplatesByCategory,
  searchFormats,
  closeSidebar,
};

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewAllTemplates))
);
